import { useEffect } from "react"


export const useStart = ($, ...params) => useEffect(() => {
    const p = $.start.apply(null, params)
    return () => p.cancel()
},  params || [])